export const currencyFormat = (amount: string) => {
    if (!amount || amount == "0.00") {
        return '';
    }

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(Number(amount));
} 